import React from 'react';
import PropTypes from 'prop-types';

import {createFragmentContainer} from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import SimpleList from './SearchList/SimpleList';
import DropDownSearch from './SearchList/DropDownSearch';
import SearchSelect from './SearchList/SearchSelect';
import SearchSelectCreateNewField from './SearchList/SearchSelectCreateNewField';
import IconSelect from './SearchList/IconSelect'

const SearchListComponent = ({
  form,
  field,
  type,
  selected_value_type,
  ...other
}) => {
  switch(type) {
    case "search": return <DropDownSearch {...other} />;
    case "icon-search": return <IconSelect {...other} />;
    case "search-select-field": return <SearchSelect {...other} />;
    case "search-select-button": return <SearchSelectCreateNewField {...other} />;
    default: return <SimpleList {...other} />;
  }
}

SearchListComponent.propTypes = {
  input_props: PropTypes.object,
  selected_value: PropTypes.string,
  icon_type: PropTypes.string,
  search_value: PropTypes.string,
  selected_value: PropTypes.string,
  onSelect: PropTypes.func,

  // formik implementation
  name: PropTypes.string.isRequired,
  selected_value_type: PropTypes.string.isRequired
}

SearchListComponent.defaultProps = {
  name: "search-list-field",
  selected_value_type: "name"
}


//export default React.memo(SearchListComponent);
export default SearchListComponent;
